<div class="container container-fixed">
  <div class="row">
    @for (tag of allTags; track tag; let i = $index) {
      <div class="col-xs-6 col-sm-4 col-md-3 col-xl-2">
        <div class="form-group">
          <div class="control control-checkbox">
            <label>{{tag.Name}}<input type="checkbox" [disabled]="!isEditing" [(ngModel)]="allChecks[i]" /><i></i></label>
          </div>
        </div>
      </div>
    }
  </div>
  <div class="row">
    <div class="col-md-12">
      @if (!isEditing) {
        <button class="btn btn-primary" type="button" (click)="edit()" *bizPermissionRequired="['Partner_Action_GeneralEdit', 'Partner_Action_InternalPartner']; type:'And'; evaluator:evaluatePermissions; trigger: selectedPartner">Edit</button>
      }
      @if (isEditing) {
        <button class="btn btn-primary" type="button" (click)="save()">Save</button>
        <button class="btn btn-link" type="button" (click)="cancel()">Cancel</button>
      }
    </div>
  </div>
</div>
